/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeoItemId
 */
export interface HeoItemId {
    /**
     * 
     * @type {string}
     * @memberof HeoItemId
     */
    companyCode: string;
    /**
     * 
     * @type {number}
     * @memberof HeoItemId
     */
    number: number;
}

/**
 * Check if a given object implements the HeoItemId interface.
 */
export function instanceOfHeoItemId(value: object): value is HeoItemId {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function HeoItemIdFromJSON(json: any): HeoItemId {
    return HeoItemIdFromJSONTyped(json, false);
}

export function HeoItemIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeoItemId {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCode': json['companyCode'],
        'number': json['number'],
    };
}

export function HeoItemIdToJSON(json: any): HeoItemId {
    return HeoItemIdToJSONTyped(json, false);
}

export function HeoItemIdToJSONTyped(value?: HeoItemId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyCode': value['companyCode'],
        'number': value['number'],
    };
}

